import { ArchivesMutationTypes } from './mutation_types'
import { ArchivesState } from './state'

export const mutations: StoreMutations<ArchivesMutationTypes, ArchivesState> = {
  [ArchivesMutationTypes.SET_DISCOVER_ELECTRONIC_SAFE_DIALOG_IS_OPEN] (state, value) {
    state.discoverElectronicSafeDialogIsOpen = value
  },
  [ArchivesMutationTypes.SET_LIST_SEARCH_PENDING]: function (state, value) {
    state.listSearchPending = value
  },
  [ArchivesMutationTypes.SET_LIST_SEARCH_DATA]: function (state, value) {
    state.listSearchData = value
  },
  [ArchivesMutationTypes.SET_LIST_SEARCH_DATA_COUNT]: function (state, value) {
    state.listSearchDataCount = value
  },
  [ArchivesMutationTypes.SET_CONFIG]: function (state, value) {
    state.config = value
  },
  [ArchivesMutationTypes.SET_CONFIG_PENDING]: function (state, value) {
    state.configPending = value
  },
  [ArchivesMutationTypes.SET_GET_ARCHIVE_RIGHTS_PENDING]: function (state, value) {
    state.getArchiveRightsPending = value
  },
  [ArchivesMutationTypes.SET_CURRENT_ARCHIVE_RIGHTS]: function (state, value) {
    state.currentArchiveRights = value
  },
  [ArchivesMutationTypes.SET_SEND_ARCHIVES_PENDING]: function (state, value) {
    state.sendArchivesPending = value
  },
  [ArchivesMutationTypes.SET_SHARE_ARCHIVES_PENDING]: function (state, value) {
    state.shareArchivesPending = value
  },
  [ArchivesMutationTypes.SET_MUTE_ARCHIVING_WARNING] (state, value) {
    state.muteArchivingWarning = value
  },
  [ArchivesMutationTypes.ADD_UPLOAD_ARCHIVE_PENDING] (state, value) {
    state.uploadArchivePendingIds.push(value)
  },
  [ArchivesMutationTypes.REMOVE_UPLOAD_ARCHIVE_PENDING] (state, index) {
    state.uploadArchivePendingIds.splice(index, 1)
  },
  [ArchivesMutationTypes.ADD_UPLOAD_ARCHIVE_ERROR] (state, value) {
    state.uploadArchiveErrors.push(value)
  },
  [ArchivesMutationTypes.REMOVE_UPLOAD_ARCHIVE_ERROR] (state, index) {
    state.uploadArchiveErrors.splice(index, 1)
  },
  [ArchivesMutationTypes.ADD_POST_ARCHIVE_PENDING] (state, value) {
    state.postArchivePendingIds.push(value)
  },
  [ArchivesMutationTypes.REMOVE_POST_ARCHIVE_PENDING] (state, index) {
    state.postArchivePendingIds.splice(index, 1)
  },
  [ArchivesMutationTypes.ADD_POST_ARCHIVE_ERROR] (state, value) {
    state.postArchiveErrors.push(value)
  },
  [ArchivesMutationTypes.REMOVE_POST_ARCHIVE_ERROR] (state, index) {
    state.postArchiveErrors.splice(index, 1)
  },
  [ArchivesMutationTypes.SET_SELECTED_DOCUMENTS] (state, selectedDocuments) {
    state.selectedDocuments = selectedDocuments
  },
  [ArchivesMutationTypes.SET_ARCHIVES_DOWNLOAD_PENDING] (state, value) {
    state.archivesDownloadPending = value
  },
  [ArchivesMutationTypes.REMOVE_DOCUMENT] (state, index) {
    state.selectedDocuments.splice(index, 1)
  },
}
